import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, useProSidebar, SubMenu } from "react-pro-sidebar";
import { Outlet, Link, useLocation } from "react-router-dom";
import { BiMenu, BiMenuAltRight } from "react-icons/bi";
import { Button } from "react-bootstrap";
import Header from "./Common/header";
import { MyDiv, PTag } from "./Common/Components";
import { menuConfig, singleMenuItems } from "./menuConfig";
import useResponsiveDevice from "./customHook"; // <-- Update the path
import MobileMenuOverlay from "../mobile/MobileMenuOverlay";
import { AiOutlineMenuUnfold, AiOutlineMenuFold  } from "react-icons/ai";

function TemplateCore() {
  const { collapseSidebar } = useProSidebar();
  const pathname = useLocation().pathname;
  const RolePermission = JSON.parse(localStorage.getItem("role"));

  const [openMenu, setOpenMenu] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [hide, setHide] = useState(true);

  // Get the current device from your custom hook
  const currentDevice = useResponsiveDevice();

  const isMobile = currentDevice === "mobile";
  const isTablet = currentDevice === "tablet";
  const isMobileOrTablet = isMobile || isTablet;

  useEffect(() => {
    setOpenMenu(null);

    if (!isCollapsed) {
      collapseSidebar();
      setIsCollapsed(true);
    }

    if (isMobileOrTablet) {
      setHide(true);
    }
  }, [pathname]);

  const handleToggleSidebar = () => {
    if (isMobileOrTablet) {
      setHide((prev) => !prev);
    } else {
      collapseSidebar();
      setIsCollapsed((prev) => !prev);
    }
  };

  const handleMenuClick = (menuKey) => {
    setOpenMenu((prev) => (prev === menuKey ? null : menuKey));
  };

  const MenuLink = ({ to, children, ...props }) => (
    <Link
      to={to}
      {...props}
      onClick={() => {
        setOpenMenu(null);

        if (isMobileOrTablet) {
          setHide(true);
        }
      }}
    >
      {children}
    </Link>
  );

  const isPathActive = (paths) => paths.some((p) => pathname.startsWith(p));
  const isExactPath = (path) => pathname === path;

  const isItemActive = (item) =>
    item.matchType === "exact"
      ? isExactPath(item.path)
      : pathname.startsWith(item.path);

  const isDeviceAllowed = (moduleKey) => {
    if (!moduleKey) return true;

    const moduleData = RolePermission?.[moduleKey];

    if (!moduleData?.allowed_devices) return true;

    return !!moduleData.allowed_devices[currentDevice];
  };

  const isVisible = (entry) =>
    entry.permission(RolePermission) && isDeviceAllowed(entry.moduleKey);

  const renderSubMenu = (menu) => {
    if (!isVisible(menu)) return null;

    const visibleItems = menu.items.filter(isVisible);

    if (visibleItems.length === 0) return null;

    const MenuIcon = menu.icon;

    return (
      <SubMenu
        key={menu.key}
        open={openMenu === menu.key}
        onClick={() => handleMenuClick(menu.key)}
        label={menu.label}
        className={isPathActive(menu.activePaths) ? "menuActive" : ""}
        icon={<MenuIcon />}
      >
        {visibleItems.map((item) => {
          const ItemIcon = item.icon;

          return (
            <MenuItem
              key={item.path}
              className={
                isItemActive(item)
                  ? "menuActive submenuItem"
                  : "submenuItem"
              }
              component={<MenuLink to={item.path} />}
              icon={<ItemIcon />}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </SubMenu>
    );
  };

  const renderSingleItem = (item) => {
    if (!isVisible(item)) return null;

    const ItemIcon = item.icon;

    return (
      <MenuItem
        key={item.key}
        className={isPathActive(item.activePaths) ? "menuActive" : ""}
        icon={<ItemIcon />}
        component={<MenuLink to={item.path} />}
      >
        {item.label}
      </MenuItem>
    );
  };

  return (
    <div>
      <Header />

      <MyDiv className="GeneralContainer">
        <MyDiv className="LeftSideContainer">
          <Button className="SidebarCollapse" onClick={handleToggleSidebar}>
            {(isMobile && hide) || (!isMobile && isCollapsed) ? <AiOutlineMenuUnfold  /> : <AiOutlineMenuFold />}
          </Button>

          {isMobile ? (
              <MobileMenuOverlay
                  open={!hide}
                  onClose={() => setHide(true)}
                  menuConfig={menuConfig}
                  singleMenuItems={singleMenuItems}
                  RolePermission={RolePermission}
                  currentDevice={currentDevice}
              />
          ) : (
              <Sidebar
                  collapsed={isCollapsed}
                  hidden={isTablet && hide}
              >
                  <Menu>
                      {menuConfig.map(renderSubMenu)}
                      {singleMenuItems.map(renderSingleItem)}
                  </Menu>
              </Sidebar>
          )}
        </MyDiv>

        <MyDiv className="RightMainContainer">
          <MyDiv className="Right-Side-Main-Container">
            <Outlet />
          </MyDiv>

          <MyDiv className="footer-copyrights">
            <PTag className="text-center mt-15">
              {new Date().getFullYear()} @ ENCORE. All rights reserved
            </PTag>
          </MyDiv>
        </MyDiv>
      </MyDiv>
    </div>
  );
}

export default TemplateCore;